
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{staticClass:"toFill",attrs:{"d":"M21.212 2.304h0v-.01C21.18 1.437 20.507.75 19.658.75H4.302c-.84 0-1.552.68-1.552 1.554v20.074c0 .84.678 1.554 1.552 1.554H19.66c.84 0 1.553-.68 1.553-1.554V2.304zM19.87 22.35a.237.237 0 01-.238.239H4.302a.237.237 0 01-.238-.239V2.304c0-.134.105-.24.238-.24h15.33c.133 0 .238.106.238.24V22.35z","fill":"#042132","stroke":"#042132","stroke-width":".5"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M17.157 18.407v-.022a.672.672 0 00-.197-.418.62.62 0 00-.437-.167H7.407a.617.617 0 00-.607.607c0 .328.28.608.607.608h9.143c.328 0 .607-.28.607-.608z","fill":"#042132","stroke":"#042132","stroke-width":".4"}}),_c('path',{staticClass:"toStroke",attrs:{"d":"M10.9 10.15v.75h5.086A4.401 4.401 0 1110.9 5.814v4.336z","stroke":"#042132","stroke-width":"1.5"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M13.6 4.613A4.404 4.404 0 0117.186 8.2H13.6V4.613z","fill":"#042132","stroke":"#042132","stroke-width":"1.5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    